import OnboardingAd from '@/ui/components/OnboardingAd.vue';
import ShoprenterStartSubscriptionModal from '@/ui/components/ShoprenterStartSubscriptionModal.vue';

export default {
  computed: {
    isLoading() {
      return this.$store.getters['dashboard/isLoading'];
    },
    dashboardData: {
      get() {
        return this.$store.getters['dashboard/dashboardData'];
      },
      set(value) {
        this.$store.commit('dashboard/setDashboardData', value);
      },
    },
    onboardingNecessary() {
      if (!this.$root.isLoggedIn || !this.$root.isInOriginalCompany) {
        return false;
      }

      return this.$root.currentCompany.connected_profiles.length === 0 || this.$root.currentCompany.brands.length === 0;
    },
  },
  methods: {
    openOnboardingModal() {
      if (this.$app.isShoprenterApp && !this.$root.currentCompany?.current_subscription) {
        this.$fullscreenModal.open(
          this,
          ShoprenterStartSubscriptionModal,
          {},
          { closable: true },
        );
        return;
      }

      this.$fullscreenModal.open(
        this,
        OnboardingAd,
        {},
        { closable: true },
      );
    },
  },
};
